import Network from "../../../../../services/Network";
import { POST_PROPERTY, SCRAPE_OTA_DETAILS, GET_SCRAPED_DETAILS, FETCH_PROPERTY_BASIC_INFO } from "../../../../../utils/endpoints";
import { isEmptyString, path } from '../../../../../utils';

export const fetchPropertyDetails = (id, resolve, reject) => Network.GET(FETCH_PROPERTY_BASIC_INFO + id, null, null, resolve, reject);

export const mapFormToOtaList = data => data.otas.map(ota => ({
    url: ota.url,
    bd_email: 'discovery.alerts@oyorooms.com',
    ota_type: ota.agent.id,
}));

export const createProperty = (data, resolve, reject) => Network.POST(POST_PROPERTY, null, data, null,
    response => resolve(response.property_unique_id),
    reject
);

export const syncOta = (data, resolve, reject) => Network.POST(SCRAPE_OTA_DETAILS, null, { data }, null,
    response => {
        if (path(response, '0.id') == null) reject ('Incorrect response from Sync Trigger');
        let interval, timeout, success;
        interval = setInterval(() => checkOtaSyncStatus(response[0].id, data => {

            if (success === false) return;
            if (data && !isEmptyString(data.property_name)) {
                timeout && clearTimeout(timeout);
                interval && clearInterval(interval);
                resolve(data);
            }
        },(error) => {
            if (success === false) return;

            console.log(error)
            reject(error.error)
            timeout && clearTimeout(timeout);
            interval && clearInterval(interval);
        }), 3000);
        timeout = setTimeout(() => {
            success = false;
            interval && clearInterval(interval);
            reject('Timed out while fetching Details');
        }, 16000);
    },
    reject
);

const mapScrappedProperty = (response) => {
    // map properties to required format
    let data = {};
    
    if(response.property_details){
        data.property_name = path(response.property_details,"name");
        data.address = path(response.property_details,"address");
        data.scraping_request_id = response.id;
        let loc = path(response.property_details,'lat_long',"").split(",");
        if(loc.length == 2){
            data.lat = parseFloat(loc[0]);
            data.lng = parseFloat(loc[1]);
        }
    }
    
    return data
    
}

export const checkOtaSyncStatus = (id, resolve, reject) => Network.GET(GET_SCRAPED_DETAILS, { id }, null, response => resolve(mapScrappedProperty(response)), reject);